import React, { useRef, useState, useEffect } from "react";
import { YhBox } from "@/components/YhBox";
import { FormItemTypeEnum, IYhForm, IYhFormRef } from "@/components/YhFormBox/Types";
import { ICaseDetail } from "../../caseTypes";
import { YhForm } from "@/components/YhFormBox";
import "../../case.scss"
import { Button } from "antd";
import { useAbroadModel } from "../abroadModel"
import useNavModel, { RouterParamType } from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { caseService } from "../../caseService";
export const DetailsBox = () => {
    const { addFormVal, addMd5FormVal, editFormVal, editMd5FormVal, insertDetail, setAddMd5List, setEditMd5List, editDetail, setAddFormVal, setEditFormVal,
        setAddMd5FormVal, setEditMd5FormVal, getDetailEditOne, setSelectedRowKeys,
        resetAddCatch, resetEditCatch,
        loadData
    } = useAbroadModel();
    const { selectedNavId, getSelectedNavState, findNav, replaceNav } = useNavModel();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    const { id, mode } = detailsInfo;
    useEffect(() => {
        if (!Object.keys(editFormVal).length && mode === "edit") {
            getDetailEditOne(id, mode)
        }
    }, [id, mode])
    useEffect(() => {
        return () => {
            !findNav("3-2-1") && resetAddCatch(mode) && formRef.current?.resetFields();
            !findNav("3-2-2") && resetEditCatch(mode) && formRef.current?.resetFields();
        }
    }, [selectedNavId])
    const formRef = useRef<IYhFormRef>();
    const imgFormRef = useRef<IYhFormRef>();

    const onChange = (changedValues: { [key: string]: any }) => {
        mode === "add" ? setAddFormVal({ ...addFormVal, ...changedValues }) : setEditFormVal({ ...editFormVal, ...changedValues })
    }
    const formConfig: IYhForm<ICaseDetail> = {
        formRef,
        labelCol: { span: 6 },
        formValues: mode === "add" ? {
            ...addFormVal,
            status: editFormVal.status === 1,
            homeFlag: editFormVal.homeFlag === 1,
        } : {
            ...editFormVal,
            status: editFormVal.status === 1,
            homeFlag: editFormVal.homeFlag === 1,
        },
        // onChange,
        items: [
            {
                type: FormItemTypeEnum.Input,
                span: 24,
                fieldLabel: "文章标题",
                fieldName: "title",
                rules: [{ required: true, message: "请输入文章标题" }]
            },
            {
                type: FormItemTypeEnum.Input,
                span: 24,
                fieldLabel: "关键词",
                fieldName: "keywords",
                rules: [{ required: true, message: "请输入关键词" }]
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "创建人",
                fieldName: "createUser",
                span: 24,
                disable: true
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "创建时间",
                fieldName: "createTime",
                span: 24,
                disable: true
            },
            {
                type: FormItemTypeEnum.Switch,
                fieldLabel: "置顶",
                fieldName: "status",
                span: 24,
            },
            {
                type: FormItemTypeEnum.Switch,
                fieldLabel: "推荐到首页",
                fieldName: "homeFlag",
                span: 24,
            },
        ]
    }
    const onSetFieldsValue = (formValues: { [key: string]: any }, isFormItem: boolean = true) => {
        mode === "add" ? setAddMd5FormVal(formValues.image) : setEditMd5FormVal(formValues.image)
    }
    const imgformConfig: IYhForm<ICaseDetail> = {
        formRef: imgFormRef,
        labelCol: { span: 3 },
        formValues: {},
        items: [
            {
                type: FormItemTypeEnum.FileImage,
                fieldLabel: "图片上传",
                fieldName: "image",
                span: 24,
                md5List: mode === "add" ? addMd5FormVal : editMd5FormVal,
                onSetFieldsValue
            },
        ]
    }
    const onSubmit = () => {
        formRef.current?.validateFields().then(async (res: any) => {
            let { status, homeFlag, ...params } = res
            const data = {
                ...params,
                status: status ? 1 : 0,
                homeFlag: homeFlag ? 1 : 0,
                type: "interna",
            }
            if (mode === "add") {
                const retData = await insertDetail(data)
                if (retData) {
                    globalPrompt("message", { text: "国际案例新增成功", type: "success" })
                    goBack();
                    setSelectedRowKeys([]);
                    setAddMd5FormVal([]);
                    setAddMd5List([]);
                }
            } else {
                const retData = await editDetail({ ...data, id })
                if (retData) {
                    globalPrompt("message", { text: "国际案例编辑成功", type: "success" })
                    goBack();
                    setSelectedRowKeys([]);
                    setEditMd5FormVal([]);
                    setEditMd5List([]);
                }
            }
        })
    }
    const goBack = async () => {
        await loadData()
        replaceNav(selectedNavId, "3-2")
    }
    const onTranslate = async () => {
        console.log(addFormVal);
        let { title, keywords } = mode === "add" ? addFormVal : editFormVal;
        let { retData } = await caseService.translation({ title, keywords })
        mode === "add" ? setAddFormVal(retData) : setEditFormVal(retData)
    }
    return <YhBox title="国际案例详情">
        <div style={{ display: "flex" }}>
            <div className="form-left">
                <YhForm  {...formConfig} />
                <div className="form-btn">
                    <Button type="link" shape="round" onClick={onTranslate}>翻译</Button>
                    <Button type="link" shape="round" onClick={onSubmit}>发布</Button>
                    <Button type="link" shape="round" onClick={goBack}>返回</Button>
                </div>
            </div>
            <div className="img-right">
                <YhForm  {...imgformConfig} />
            </div>
        </div>
    </YhBox>
}